/**
 * This composable should encapsulate the api-cache typical functionality for a store
 * ie, the crud operations of fetchAll, update, create, delete, (getById?)
 */
import { ref, computed, watch } from 'vue'
import * as yup from 'yup';
import { useCacheStore, useAlertStore, useWatchlistStore } from '@/stores';
import { ApiError } from '@/libs/axios';
import { type SMPObject } from '@/stores/cache-store'
import router from '@/router'



export function useStoreSyncer(endpoint : string, name : string) {
    const cache = useCacheStore();
    const alert = useAlertStore();
    const error = ref<Error | null>(null);
    const loading = ref<boolean>(false);
    const allItems = computed<Array<any>>(()=>{
        return cache.getFromCache(name) || [];
    })

    /**
     * 
     * @returns 
     */
    async function fetchAll() : Promise<Array<SMPObject>>{
        console.log("Store-syncer.fetchAll() for " + name)
        alert.success("Fetching all " + name + " from backend...")
        loading.value = true;
        let data : Array<SMPObject> = [];
        try {
            data = await cache.fetchAndWriteToCache(name, endpoint);
            alert.success("Fetching all " + name + " from backend...done!");
            //alert.clear(1000);
        } catch (error) {
            console.error('Error in fetchAll ..' + error)
            alert.error(error);
            alert.clear(3000);
            setTimeout(() => {
                loading.value = false;
            }, 3000)
      
        }
        
     //   console.log("..returning data(array) = " + data);
        //simulate api fetch delay:
        //setTimeout(() =>{
            loading.value = false;
            alert.clear();
            return data;
       // }, 5000)
       // return data;
    }
    /**
     * 
     * @param obj 
     */
    async function update(obj : Object, schema : yup.Schema, returnName : string) : Promise<SMPObject>{
        console.log("Store-syncer.update() for " + name)
        //1. validate object
 //       console.log('validating object : ' + JSON.stringify(obj))
        loading.value = true;
        let parsed = null;
        try {
            parsed = await schema.validate(obj, { stripUnknown: true })
    //        console.log('parsed = ' + JSON.stringify(parsed))
        } catch (err) {
            //err.name; // => 'ValidationError'
            //err.errors; // => ['Deve ser maior que 18']
            //throw new Error('fucked');
            error.value = err.toString();
            console.log(err)
            alert.error(err)
            setTimeout(() => {
                alert.clear()
                loading.value = false;
            }, 3000)
        }

        //2.object is valid, proceed
        if (parsed) {
            let updated;
            try{
                updated = await cache.putAndUpdateCache(name, `${endpoint}/${obj.id}`, parsed, returnName)
            }catch(err){
                console.log("..error updating " + returnName)
                if(err instanceof ApiError){
                    alert.error(err.message)
                }else{
                    throw err;
                }
            }

            if(updated){
                //alert.success(`updated ${returnName} succesfull : ` + JSON.stringify(updated));
                alert.success(`updated ${returnName} ${updated.id} succesful`);
                
                setTimeout(() =>{
                    alert.clear()
                    loading.value = false;
                }, 3000)
                
            }        
            return updated;    
        }
        else{
            return { id : 'not updated'}
        }
    }

    /**
     * 
     * @param obj 
     * @param schema 
     * @param returnName 
     */
    async function create(obj : Object, schema : yup.Schema, returnName : string) : Promise<SMPObject>{
        console.log("Store-syncer.create() for " + name)
        //1. validate the object, use alert store to display messages
        loading.value = true;
        error.value = null;
        //let parsed = null;
       // let created : SMPObject= { id : 'not created'};
        try {
            const parsed = await schema.validate(obj, { stripUnknown: true }) //remove extra fields
         //   console.log('parsed = ' + JSON.stringify(parsed))
            const created : SMPObject = await cache.postAndUpdateCache(name, endpoint, parsed, returnName);
       //     console.log("2..store syncer create, created = " + JSON.stringify(created));
            alert.success(`created ${returnName} ${created.id} succesful`);
            loading.value = false;
            return created;
           /* await new Promise(resolve => setTimeout(()=>{
                alert.clear()
                loading.value = false;
                //return added;
            }, 2000));*/
            

        } catch (err : any) {
            //err.name; // => 'ValidationError'
            //err.errors; // => ['Deve ser maior que 18']
            error.value = err.toString()
            console.log(err)
            console.log("err.name = " + err.name)
            alert.error(err)
            await new Promise(resolve => setTimeout(()=>{
                alert.clear()
                loading.value = false;
                error.value = null;
            }, 3000));
            return { id : 'not created'}
            /*setTimeout(() => {
                alert.clear()
                loading.value = false;
                error.value = null;
            }, 3000)*/
           // return
        }
      

    }

    /**
     * TODO api needs to return deleted
     * @returns 
     */
    async function remove(id : any) : Promise<Object>{
        console.log("Store-syncer.remove() for " + name);
        const deleted = await cache.deleteAndUpdateCache(name, `${endpoint}/${id}`, 'deleted');
        if(deleted){
            //alert.success('deleted succesfull : ' + JSON.stringify(deleted));
            alert.success(`deleted ${name} ${id} succesfull`);
            setTimeout(() =>{
                alert.clear()
                loading.value = false;
                if(name === "invoices"){
                    router.push(`/projects/${deleted.projectId}/invoices`)
                }else if(name === "postech"){
                    router.push({ name: 'project_postechs', params: { projectId: deleted.projectId } })
                }else if(name === "projects"){
                    //const shortlistStore = useShortlistStore();
                    //shortlistStore.remove(deleted.id);
                    const watchlistStore = useWatchlistStore();
                    watchlistStore.remove(id);
                    router.push('/projects/list');
                }else if(name === "customers"){
                    router.push('/customers/list');
                }
            }, 2000)
        }
        //return deleted;
    }

    watch(loading, () =>{
        console.log("..store-syncer watching loading = " + loading.value);
    })

  return { allItems, fetchAll, update, create, remove, loading, error }
}